"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  GestureSwipeHorizontalRight2: ['gesture-swipe-horizontal-right-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.611,23.248l-3.79-3.093a1.639,1.639,0,0,1-.566-1.676h0a1.639,1.639,0,0,1,2.321-1.068L9.751,18v-6.75a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333a3,3,0,0,1,2.507,2.959v4.208', 'M23.25 3.748L23.25 9.748 17.25 9.748', 'M.75,7.128a18,18,0,0,1,22.5,1.205']],
  GestureFlipRight: ['gesture-flip-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.939 11.964L5.4 11.623', 'M9.1,14.257,8.15,10.211a3.75,3.75,0,1,0-7.3,1.705L2.618,19.5', 'M20.057 11.964L18.596 11.623', 'M21.378,19.5l1.771-7.582a3.75,3.75,0,0,0-7.3-1.7L14.9,14.244', 'M13.691 17.272L16.414 20.526 13.16 23.248', 'M16.4,20.507A26.959,26.959,0,0,1,7.227,19.1', 'M11.387 6.748L7.981 4.219 10.51 0.813', 'M8,4.234a26.944,26.944,0,0,1,9.248-.766']],
  GestureExpand: ['gesture-expand', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.25 2.998L12 0.748 9.75 2.998', 'M14.25 20.998L12 23.248 9.75 20.998', 'M3 9.748L0.75 11.998 3 14.248', 'M21 9.748L23.25 11.998 21 14.248', 'M12.75 11.248L11.25 11.248', 'M8.25,17.248V10.5a3.75,3.75,0,0,1,7.5,0v6.75']],
  GestureSwipeHorizontalLeft: ['gesture-swipe-horizontal-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.249 12.748L12.749 12.748', 'M9.749,23.248V12a3.75,3.75,0,1,1,7.5,0v11.25', 'M0.748 0.748L0.748 6.748 6.748 6.748', 'M23.248,4.128A18,18,0,0,0,.748,5.333']],
  GestureExpandTwoFingers: ['gesture-expand-two-fingers', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.25 2.998L12 0.748 9.75 2.998', 'M14.25 20.998L12 23.248 9.75 20.998', 'M3 9.748L0.75 11.998 3 14.248', 'M21 9.748L23.25 11.998 21 14.248', 'M9.749,12.748a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M14.625,11.248a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M6.75,15.748l0-3a3,3,0,0,1,6,0v3', 'M17.25,15.748V10.873a2.625,2.625,0,0,0-5.248-.1']],
  GestureExpand1: ['gesture-expand-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.608,17.248,6.819,14.155a1.639,1.639,0,0,1-.566-1.676h0a1.638,1.638,0,0,1,2.321-1.068L9.748,12V6.748a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v3l1.993.333a3,3,0,0,1,2.507,2.959v4.208', 'M14.248 2.998L11.998 0.748 9.748 2.998', 'M14.248 20.998L11.998 23.248 9.748 20.998', 'M2.998 9.748L0.748 11.998 2.998 14.248', 'M20.998 9.748L23.248 11.998 20.998 14.248']],
  GestureSwipeHorizontal: ['gesture-swipe-horizontal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 9.748L5.25 9.748', 'M4.5 5.998L0.75 9.748 4.5 13.498', 'M18.75 9.748L23.25 9.748', 'M19.5 5.998L23.25 9.748 19.5 13.498', 'M12.75 12.748L11.25 12.748', 'M8.25,23.248V12a3.75,3.75,0,1,1,7.5,0v11.25']],
  GestureSwipeHorizontal2: ['gesture-swipe-horizontal-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.11,23.248,8.321,20.155a1.639,1.639,0,0,1-.566-1.676h0a1.638,1.638,0,0,1,2.321-1.068L11.25,18v-6.75a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333A3,3,0,0,1,18.75,19.04v4.208', 'M3.75 0.748L0.75 3.748 3.75 6.748', 'M8.25 0.748L5.25 3.748 8.25 6.748', 'M20.25 0.748L23.25 3.748 20.25 6.748', 'M15.75 0.748L18.75 3.748 15.75 6.748', 'M5.25 3.748L18.75 3.748']],
  GestureScroll: ['gesture-scroll', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.499 4.498L18.749 0.748 14.999 4.498', 'M18.749 0.748L18.749 23.248', 'M22.499 19.498L18.749 23.248 14.999 19.498', 'M6.749 8.248L6.749 6.748', 'M.749,3.748H7.5a3.75,3.75,0,1,1,0,7.5H.749', 'M8.249 15.748L8.249 14.248', 'M.749,11.248H9a3.75,3.75,0,0,1,0,7.5H.749']],
  GestureSwipeHorizontalLeft3: ['gesture-swipe-horizontal-left-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.748 3.748L0.748 9.748 6.748 9.748', 'M3.748 0.748L3.748 6.748 9.748 6.748', 'M3.748,5.18a20.279,20.279,0,0,1,19.5-.827', 'M12.109,23.248l-3.79-3.093a1.636,1.636,0,0,1-.565-1.676h0a1.638,1.638,0,0,1,2.321-1.068L11.249,18v-6.75a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333a3,3,0,0,1,2.507,2.959v4.208']],
  GestureSwipeHorizontalLeft1: ['gesture-swipe-horizontal-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.748 14.248L17.248 14.248', 'M20.248,23.248V13.5a3.75,3.75,0,0,0-7.5,0v9.75', 'M0.747 3.748L0.747 9.748 6.747 9.748', 'M3.747 0.748L3.747 6.748 9.747 6.748', 'M3.747,5.18a20.279,20.279,0,0,1,19.5-.827']],
  GestureSwipeHorizontalRight: ['gesture-swipe-horizontal-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.249 12.748L9.749 12.748', 'M6.749,23.248V12a3.75,3.75,0,1,1,7.5,0v11.25', 'M23.249 0.748L23.249 6.748 17.249 6.748', 'M.749,4.128a18,18,0,0,1,22.5,1.205']],
  GestureSwipeHorizontalRight1: ['gesture-swipe-horizontal-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.748 14.248L8.248 14.248', 'M11.248,23.248V13.5a3.75,3.75,0,1,0-7.5,0v9.75', 'M23.248 3.748L23.248 9.748 17.248 9.748', 'M20.248 0.748L20.248 6.748 14.248 6.748', 'M20.248,5.18a20.279,20.279,0,0,0-19.5-.827']],
  GestureTap2: ['gesture-tap-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.608,23.248,6.819,20.155a1.639,1.639,0,0,1-.566-1.676h0a1.638,1.638,0,0,1,2.321-1.068L9.748,18v-6.75a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333a3,3,0,0,1,2.507,2.959v4.208', 'M18.877,14.486A8.992,8.992,0,1,0,2.248,9.748a8.922,8.922,0,0,0,1.69,5.222']],
  GestureSwipeHorizontalLeft2: ['gesture-swipe-horizontal-left-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.11,21.748,8.32,18.655a1.636,1.636,0,0,1-.565-1.676h0a1.638,1.638,0,0,1,2.321-1.068l1.174.587V9.748a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333A3,3,0,0,1,18.75,17.54v4.208', 'M0.749 2.248L0.749 8.248 6.749 8.248', 'M23.249,5.628A18,18,0,0,0,.749,6.833']],
  GestureSwipeVertical: ['gesture-swipe-vertical', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17 0.748L17 5.248', 'M20.75 4.498L17 0.748 13.25 4.498', 'M17 18.748L17 23.248', 'M20.75 19.498L17 23.248 13.25 19.498', 'M14 12.748L14 11.248', 'M3.25,8.248h11.5a3.75,3.75,0,0,1,0,7.5H3.266']],
  GestureSwipeVertical1: ['gesture-swipe-vertical-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.249 3.748L20.249 0.748 17.249 3.748', 'M23.249 8.248L20.249 5.248 17.249 8.248', 'M23.249 20.248L20.249 23.248 17.249 20.248', 'M23.249 15.748L20.249 18.748 17.249 15.748', 'M20.249 5.248L20.249 18.748', 'M9.748 11.248L9.748 12.748', 'M.748,15.748H10.5a3.75,3.75,0,0,0,0-7.5H.748']],
  GestureSwipeVertical2: ['gesture-swipe-vertical-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,12.109,3.843,8.32a1.639,1.639,0,0,1,1.676-.566h0a1.638,1.638,0,0,1,1.068,2.321L6,11.249h6.75a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5H8.25l-.332,1.993a3,3,0,0,1-2.96,2.507H.75', 'M23.249 3.748L20.249 0.748 17.249 3.748', 'M23.249 8.248L20.249 5.248 17.249 8.248', 'M23.249 20.248L20.249 23.248 17.249 20.248', 'M23.249 15.748L20.249 18.748 17.249 15.748', 'M20.249 5.248L20.249 18.748']],
  GestureSwipeVerticalDown: ['gesture-swipe-vertical-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.249 11.248L11.249 9.748', 'M.749,6.748H12a3.75,3.75,0,1,1,0,7.5H.749', 'M23.249 23.248L17.249 23.248 17.249 17.248', 'M19.869.748a18,18,0,0,1-1.2,22.5']],
  GestureSwipeVertical3: ['gesture-swipe-vertical-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.25,10.608,6.344,6.819a1.637,1.637,0,0,1,1.675-.566h0A1.637,1.637,0,0,1,9.087,8.574L8.5,9.748h6.75a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5h-4.5l-.332,1.994a3,3,0,0,1-2.959,2.506H3.25', 'M16.75 0.748L16.75 5.998', 'M20.5 4.498L16.75 0.748 13 4.498', 'M16.75 15.748L16.75 23.248', 'M20.5 19.498L16.75 23.248 13 19.498']],
  GestureSwipeVerticalDown2: ['gesture-swipe-vertical-down-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25,10.609,5.344,6.82a1.633,1.633,0,0,1,1.675-.566h0A1.637,1.637,0,0,1,8.087,8.575L7.5,9.749h6.75a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5H9.75l-.332,1.993a3,3,0,0,1-2.959,2.507H2.25', 'M21.75 23.248L15.75 23.248 15.75 17.248', 'M18.371.748a18,18,0,0,1-1.206,22.5']],
  GestureSwipeVerticalDown3: ['gesture-swipe-vertical-down-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.248 23.248L14.248 23.248 14.248 17.248', 'M23.248 20.248L17.248 20.248 17.248 14.248', 'M18.817,20.248a20.282,20.282,0,0,0,.826-19.5', 'M.748,10.609,3.842,6.82a1.639,1.639,0,0,1,1.676-.566h0A1.637,1.637,0,0,1,6.585,8.575L6,9.749h6.75a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5h-4.5l-.332,1.993a3,3,0,0,1-2.959,2.507H.748']],
  GestureSwipeVerticalUp1: ['gesture-swipe-vertical-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.748 15.748L9.748 17.248', 'M.748,20.248H10.5a3.75,3.75,0,0,0,0-7.5H.748', 'M20.248 0.748L14.248 0.748 14.248 6.748', 'M23.248 3.748L17.248 3.748 17.248 9.748', 'M18.817,3.748a20.282,20.282,0,0,1,.826,19.5']],
  GestureSwipeVerticalUp3: ['gesture-swipe-vertical-up-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.749,12.109,3.842,8.32a1.639,1.639,0,0,1,1.676-.566h0a1.638,1.638,0,0,1,1.068,2.321L6,11.249h6.75a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5h-4.5l-.333,1.993a3,3,0,0,1-2.959,2.507H.749', 'M20.249 0.748L14.249 0.748 14.249 6.748', 'M23.249 3.748L17.249 3.748 17.249 9.748', 'M18.817,3.748a20.15,20.15,0,0,1,2.932,10.5,20.17,20.17,0,0,1-2.105,9']],
  GestureSwipeVerticalUpTwoFingers: ['gesture-swipe-vertical-up-two-fingers', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.249 0.748L17.249 0.748 17.249 6.748', 'M19.869,23.248a18,18,0,0,0-1.2-22.5', 'M6.749 8.248L6.749 6.748', 'M.749,3.748H7.5a3.75,3.75,0,1,1,0,7.5H.749', 'M8.249 15.748L8.249 14.248', 'M.749,11.248H9a3.75,3.75,0,0,1,0,7.5H.749']],
  GestureTap: ['gesture-tap', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,23.248V12a5.25,5.25,0,0,1,10.5,0v11.25', 'M14.25,11.248v1.5H9.75v-1.5a1.5,1.5,0,0,1,1.5-1.5h1.5A1.5,1.5,0,0,1,14.25,11.248Z', 'M20.25,19.629a11.25,11.25,0,1,0-16.5,0']],
  GestureTap1: ['gesture-tap-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,23.248V15a5.25,5.25,0,1,1,10.5,0v8.25', 'M14.25 15.748L14.25 17.248 9.75 17.248 9.75 15.748', 'M23.25,6.274a14.215,14.215,0,0,0-22.5,0', 'M20.25,20.178a9.75,9.75,0,1,0-16.5,0']],
  GestureSwipeVerticalUp: ['gesture-swipe-vertical-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.249 14.248L11.249 12.748', 'M.749,9.748H12a3.75,3.75,0,0,1,0,7.5H.749', 'M23.249 0.748L17.249 0.748 17.249 6.748', 'M19.869,23.248a18,18,0,0,0-1.2-22.5']],
  GestureTapClock1: ['gesture-tap-clock-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.11,23.248,5.321,20.155a1.639,1.639,0,0,1-.566-1.676h0a1.638,1.638,0,0,1,2.321-1.068L8.25,18v-6.75a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333A3,3,0,0,1,15.75,19.04v4.208', 'M17.379,14.486a9.258,9.258,0,0,0,.844-1.736', 'M14.250 5.248 A4.500 4.500 0 1 0 23.250 5.248 A4.500 4.500 0 1 0 14.250 5.248 Z', 'M18.75 5.248L18.75 3.748', 'M12,1.065A8.9,8.9,0,0,0,9.75.748,8.979,8.979,0,0,0,2.44,14.97']],
  GestureTapClock: ['gesture-tap-clock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.378,14.515a9.2,9.2,0,0,0,.845-1.736', 'M14.250 5.277 A4.500 4.500 0 1 0 23.250 5.277 A4.500 4.500 0 1 0 14.250 5.277 Z', 'M18.75 5.277L18.75 3.777', 'M12,1.093A8.94,8.94,0,0,0,9.75.777,8.978,8.978,0,0,0,2.44,15', 'M11.25 12.748L11.25 14.248 8.25 14.248 8.25 12.748', 'M5.25,23.248v-10.5a4.5,4.5,0,1,1,9,0v10.5']],
  GestureTapExpandAllDirection: ['gesture-tap-expand-all-direction', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.999 3.748L11.999 0.748 8.999 3.748', 'M14.999 20.248L11.999 23.248 8.999 20.248', 'M3.749 8.998L0.749 11.998 3.749 14.998', 'M20.249 8.998L23.249 11.998 20.249 14.998', 'M9.749,15.748a2.25,2.25,0,0,1,0-4.5v-3a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5V10.5l.727.182a3,3,0,0,1,2.272,2.911v2.157', 'M17.249,19.3a9.085,9.085,0,0,0,2.041-2.05', 'M19.29,6.748A9.106,9.106,0,0,0,17.249,4.7', 'M4.709,17.248a9.06,9.06,0,0,0,2.04,2.05', 'M6.749,4.7a9.081,9.081,0,0,0-2.04,2.05']],
  GestureTapSwipeDown: ['gesture-tap-swipe-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.249 23.248L17.249 17.248', 'M20.999 19.498L17.249 23.248 13.499 19.498', 'M11.249 8.248L11.249 6.748', 'M.749,3.748H12a3.75,3.75,0,1,1,0,7.5H.749', 'M10.5,1.451a6.749,6.749,0,1,1,0,12.1']],
  GestureTapSwipeDown1: ['gesture-tap-swipe-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,6.108,3.844,2.319a1.637,1.637,0,0,1,1.675-.566h0A1.637,1.637,0,0,1,6.587,4.074L6,5.248h6.75a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5H8.25l-.332,1.994a3,3,0,0,1-2.959,2.506H.75', 'M15.75 23.248L15.75 15.748', 'M19.5 19.498L15.75 23.248 12 19.498', 'M11.507,10.991a6,6,0,1,0,0-8.485']],
  GestureTapSwipeHorizontal: ['gesture-tap-swipe-horizontal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.748 14.248L11.248 14.248', 'M8.248,17.248V13.5a3.75,3.75,0,0,1,7.5,0v3.75', 'M2.998 9.748L0.748 11.998 2.998 14.248', 'M20.998 9.748L23.248 11.998 20.998 14.248', 'M5.95,16.5a6.75,6.75,0,1,1,12.1,0']],
  GestureTapSwipeLeft: ['gesture-tap-swipe-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 6.748L6.75 6.748', 'M4.5 2.998L0.75 6.748 4.5 10.498', 'M15.75 12.748L17.25 12.748', 'M20.25,23.248V12a3.75,3.75,0,1,0-7.5,0v11.25', 'M22.547,13.5a6.749,6.749,0,1,0-12.1,0']],
  GestureTapHorizontalExpand: ['gesture-tap-horizontal-expand', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.5,12.109,4.594,8.32a1.633,1.633,0,0,1,1.675-.566h0a1.637,1.637,0,0,1,1.068,2.321L6.75,11.249H13.5a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5H9l-.332,1.993a3,3,0,0,1-2.959,2.507H1.5', 'M20.25 3.748L17.25 0.748 14.25 3.748', 'M20.25 20.249L17.25 23.249 14.25 20.248', 'M15,16.724a5.193,5.193,0,0,0,2.25.524,5.25,5.25,0,1,0-3.667-9']],
  GestureTapSwipeRight1: ['gesture-tap-swipe-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.108,22,2.319,18.905a1.639,1.639,0,0,1-.566-1.676h0a1.638,1.638,0,0,1,2.321-1.068l1.174.587V10a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333a3,3,0,0,1,2.507,2.959V22', 'M23.248 6.998L15.748 6.998', 'M19.498 3.248L23.248 6.998 19.498 10.748', 'M10.991,11.991a6,6,0,1,0-8.485,0']],
  GestureTapSwipeUp: ['gesture-tap-swipe-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25 0.748L17.25 6.748', 'M21 4.498L17.25 0.748 13.5 4.498', 'M11.25 15.748L11.25 17.248', 'M.75,20.248H12a3.75,3.75,0,0,0,0-7.5H.75', 'M10.5,22.546a6.75,6.75,0,1,0,0-12.1']],
  GestureTapSwipeUp1: ['gesture-tap-swipe-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.5,16.608l3.093-3.789a1.639,1.639,0,0,1,1.676-.566h0a1.638,1.638,0,0,1,1.068,2.321l-.587,1.174H13.5a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5H9l-.332,1.994a3,3,0,0,1-2.96,2.506H1.5', 'M16.498 0.748L16.498 8.248', 'M20.248 4.498L16.498 0.748 12.748 4.498', 'M12.255,13.006a6,6,0,1,1,0,8.485']],
  GestureTapSwipeVertical: ['gesture-tap-swipe-vertical', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.748 12.748L9.748 11.248', 'M6.748,8.248H10.5a3.75,3.75,0,0,1,0,7.5H6.748', 'M14.248 2.998L11.998 0.748 9.748 2.998', 'M14.248 20.998L11.998 23.248 9.748 20.998', 'M7.5,5.95a6.75,6.75,0,1,1,0,12.1']],
  GestureTapSwipeRight: ['gesture-tap-swipe-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 6.748L17.25 6.748', 'M19.5 2.998L23.25 6.748 19.5 10.498', 'M8.25 12.748L6.75 12.748', 'M3.75,23.248V12a3.75,3.75,0,1,1,7.5,0v11.25', 'M1.452,13.5a6.75,6.75,0,1,1,12.1,0']],
  GestureTwoFingerFlipLeft: ['gesture-two-finger-flip-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.064 18.704L7.377 22.935 3.146 23.248', 'M7.38,22.914a26.951,26.951,0,0,1-6.63-6.5', 'M16.576 6.081L15.285 2.04 19.326 0.748', 'M15.287,2.061A26.944,26.944,0,0,1,23.25,6.835', 'M13.293,7.533l-2.181,3.942-1.361-.227v-6a1.5,1.5,0,0,0-3,0V13.5l-1.174-.587a1.638,1.638,0,0,0-1.755,2.744', 'M14.251,18.748l.645-1.934A5.534,5.534,0,0,0,14.251,12h0L15.7,9.376']],
  GestureTapTwoFingers: ['gesture-tap-two-fingers', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.249 17.248L6.749 17.248', 'M3.749,23.248V16.5a3.75,3.75,0,0,1,7.5,0v6.75', 'M15.749 12.748L14.249 12.748', 'M11.249,23.248V12a3.75,3.75,0,1,1,7.5,0v11.25', 'M7.5,8.248A6.75,6.75,0,0,0,.749,15', 'M21.749,15.192a8.158,8.158,0,0,0,1.5-4.694A8.229,8.229,0,0,0,8.666,5.248']],
  GestureTwoFingerZoomOut: ['gesture-two-finger-zoom-out', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75,23.248l.645-1.934A5.534,5.534,0,0,0,15.75,16.5h0l2.178-3.937A1.5,1.5,0,0,0,15.3,11.108l-2.692,4.867-1.361-.227v-6a1.5,1.5,0,1,0-3,0V18l-1.174-.587a1.638,1.638,0,0,0-1.755,2.744L9.11,23.248', 'M19.459 6.612L23.249 4.705 21.343 0.915', 'M23.225,4.715a26.985,26.985,0,0,0-8.976-2.342', 'M4.539 6.612L0.749 4.705 2.655 0.915', 'M.771,4.716A26.967,26.967,0,0,1,9.749,2.373']],
  GestureTwoFingerZoomIn: ['gesture-two-finger-zoom-in', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75,23.248l.645-1.934A5.534,5.534,0,0,0,15.75,16.5h0l2.178-3.937A1.5,1.5,0,0,0,15.3,11.108l-2.692,4.867-1.361-.227v-6a1.5,1.5,0,1,0-3,0V18l-1.174-.587a1.638,1.638,0,0,0-1.755,2.744L9.11,23.248', 'M6.562 6.711L9.206 3.393 5.889 0.748', 'M9.2,3.407A35.977,35.977,0,0,0,.749,5.1', 'M17.437 6.711L14.792 3.393 18.11 0.748', 'M14.8,3.407A35.978,35.978,0,0,1,23.249,5.1']],
  GestureTwoFingersExpandAll: ['gesture-two-fingers-expand-all', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.248,17.248V13.04a3,3,0,0,0-1.5-2.6V8.248a1.5,1.5,0,0,0-3,0v-1.5a1.5,1.5,0,1,0-3,0V12l-1.174-.587a1.638,1.638,0,0,0-1.755,2.744l3.789,3.093', 'M12.748 8.248L12.748 11.248', 'M14.248 2.998L11.998 0.748 9.748 2.998', 'M14.248 20.998L11.998 23.248 9.748 20.998', 'M2.998 9.748L0.748 11.998 2.998 14.248', 'M20.998 9.748L23.248 11.998 20.998 14.248']],
  GestureTwoFingerTap: ['gesture-two-finger-tap', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.629,14.515A8.992,8.992,0,1,0,3,9.777,8.919,8.919,0,0,0,4.69,15', 'M17.25,9.777a5.25,5.25,0,0,0-10.5,0', 'M16.5,23.248l.816-2.856a3,3,0,0,0-1.543-3.507L15,16.5v-3.75a1.5,1.5,0,1,0-3,0v-1.5a1.5,1.5,0,1,0-3,0V18l-1.174-.587a1.638,1.638,0,0,0-1.755,2.744L9.86,23.248', 'M12 12.748L12 17.248']],
  GestureTwoFingersSwipeRight: ['gesture-two-fingers-swipe-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 0.748L23.25 6.748 17.25 6.748', 'M.75,4.128a18,18,0,0,1,22.5,1.205', 'M15.749,23.248l.816-2.856a3,3,0,0,0-1.543-3.507l-.773-.387v-3.75a1.5,1.5,0,0,0-3,0v-1.5a1.5,1.5,0,0,0-3,0V18l-1.174-.587A1.638,1.638,0,0,0,5.32,20.155l3.789,3.093', 'M11.249 12.748L11.249 17.248']],
  GestureTwoFingersSwipeUp: ['gesture-two-fingers-swipe-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.749,18.748l2.856.816a3,3,0,0,0,3.508-1.543l.386-.773h3.75a1.5,1.5,0,0,0,0-3h1.5a1.5,1.5,0,0,0,0-3H6l.588-1.174A1.638,1.638,0,0,0,3.843,8.319L.749,12.108', 'M11.249 14.248L6.749 14.248', 'M23.249 0.748L17.249 0.748 17.249 6.748', 'M19.87,23.248A18,18,0,0,0,18.664.748']],
  GestureTwoFingersSwipeDown: ['gesture-two-fingers-swipe-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.749,15.748l2.856.816a3,3,0,0,0,3.507-1.543l.387-.773h3.75a1.5,1.5,0,0,0,0-3h1.5a1.5,1.5,0,0,0,0-3H6l.587-1.174A1.637,1.637,0,0,0,3.843,5.319L.749,9.108', 'M11.249 11.248L6.749 11.248', 'M23.249 23.248L17.249 23.248 17.249 17.248', 'M19.87.748a18,18,0,0,1-1.206,22.5']],
  GestureTwoFingersSwipeLeft: ['gesture-two-fingers-swipe-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 0.748L0.75 6.748 6.75 6.748', 'M23.25,4.128A18,18,0,0,0,.75,5.333', 'M18.749,23.248l.816-2.856a3,3,0,0,0-1.543-3.507l-.773-.387v-3.75a1.5,1.5,0,1,0-3,0v-1.5a1.5,1.5,0,0,0-3,0V18l-1.174-.587A1.638,1.638,0,0,0,8.32,20.155l3.789,3.093', 'M14.249 12.748L14.249 17.248']],
  GestureZoomInTwoFingers: ['gesture-zoom-in-two-fingers', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5 1.498L0.75 5.248 4.5 8.998', 'M0.75 5.248L23.25 5.248', 'M19.5 1.498L23.25 5.248 19.5 8.998', 'M8.25 17.248L6.75 17.248', 'M3.75,23.248V16.5a3.75,3.75,0,0,1,7.5,0v6.75', 'M15.75 15.748L14.25 15.748', 'M11.25,23.248V15a3.75,3.75,0,1,1,7.5,0v8.25']],
  GestureTwoFingersScroll: ['gesture-two-fingers-scroll', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.248l2.856.816a3,3,0,0,0,3.507-1.543l.387-.773h3.75a1.5,1.5,0,0,0,0-3h1.5a1.5,1.5,0,0,0,0-3H6l.587-1.174A1.637,1.637,0,0,0,3.844,6.819L.75,10.608', 'M11.25 12.748L6.75 12.748', 'M22.5 4.498L18.75 0.748 15 4.498', 'M18.75 0.748L18.75 23.248', 'M22.5 19.498L18.75 23.248 15 19.498']],
  GestureTapTwoFingersClock: ['gesture-tap-two-fingers-clock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.249 20.248L6.749 20.248', 'M3.749,23.248V19.5a3.75,3.75,0,0,1,7.5,0v3.75', 'M15.749 17.248L14.249 17.248', 'M11.249,23.248V16.5a3.75,3.75,0,1,1,7.5,0v6.75', 'M7.5,11.248A6.75,6.75,0,0,0,.749,18', 'M11.249,6.161A8.344,8.344,0,0,0,8.666,8.248', 'M14.249 5.248 A4.500 4.500 0 1 0 23.249 5.248 A4.500 4.500 0 1 0 14.249 5.248 Z', 'M18.749 5.248L18.749 3.748', 'M21.749,18.192A7.891,7.891,0,0,0,22.9,11.248']],
  GestureSwipeVerticalDown1: ['gesture-swipe-vertical-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75 8.248L9.75 6.748', 'M.75,3.748H10.5a3.75,3.75,0,1,1,0,7.5H.75', 'M20.25 23.248L14.25 23.248 14.25 17.248', 'M23.25 20.248L17.25 20.248 17.25 14.248', 'M18.819,20.248a20.282,20.282,0,0,0,.826-19.5']],
  GestureSwipeHorizontalLeftTwoFingers: ['gesture-swipe-horizontal-left-two-fingers', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.749 0.748L0.749 6.748 6.749 6.748', 'M23.249,4.128A18,18,0,0,0,.749,5.333', 'M9.749 17.248L8.249 17.248', 'M5.249,23.248V16.5a3.75,3.75,0,1,1,7.5,0v6.75', 'M17.249 15.748L15.749 15.748', 'M12.749,23.248V15a3.75,3.75,0,0,1,7.5,0v8.25']],
  GestureDoubleTap: ['gesture-double-tap', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.608,23.248l-3.79-3.093a1.636,1.636,0,0,1-.565-1.676h0a1.638,1.638,0,0,1,2.321-1.068L9.748,18v-6.75a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333a3,3,0,0,1,2.507,2.959v4.208', 'M18.876,14.486A8.991,8.991,0,1,0,2.248,9.748a8.922,8.922,0,0,0,1.69,5.222', 'M15.548,12.748a5.25,5.25,0,1,0-8.6,0']],
  GestureSwipeHorizontal1: ['gesture-swipe-horizontal-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.749 0.748L0.749 3.748 3.749 6.748', 'M8.249 0.748L5.249 3.748 8.249 6.748', 'M20.249 0.748L23.249 3.748 20.249 6.748', 'M15.749 0.748L18.749 3.748 15.749 6.748', 'M5.249 3.748L18.749 3.748', 'M11.249 14.248L12.749 14.248', 'M15.749,23.248V13.5a3.75,3.75,0,0,0-7.5,0v9.75']],
  GestureSwipeHorizontalRight3: ['gesture-swipe-horizontal-right-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.61,23.248,6.82,20.155a1.639,1.639,0,0,1-.566-1.676h0a1.639,1.639,0,0,1,2.322-1.068L9.75,18v-6.75a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333A3,3,0,0,1,17.25,19.04v4.208', 'M23.249 3.748L23.249 9.748 17.249 9.748', 'M20.249 0.748L20.249 6.748 14.249 6.748', 'M20.249,5.18a20.279,20.279,0,0,0-19.5-.827']],
  GestureSwipeVerticalDownTwoFingers: ['gesture-swipe-vertical-down-two-fingers', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.248 23.248L17.248 23.248 17.248 17.248', 'M19.869.748a18,18,0,0,1-1.206,22.5', 'M6.748 8.248L6.748 6.748', 'M.748,3.748H7.5a3.75,3.75,0,0,1,0,7.5H.748', 'M8.248 15.748L8.248 14.248', 'M.748,11.248H9a3.75,3.75,0,0,1,0,7.5H.748']],
  GestureTapAllDirection: ['gesture-tap-all-direction', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.748 14.248L11.248 14.248', 'M8.248,17.248V13.5a3.75,3.75,0,0,1,7.5,0v3.75', 'M14.248 2.998L11.998 0.748 9.748 2.998', 'M14.248 20.998L11.998 23.248 9.748 20.998', 'M2.998 9.748L0.748 11.998 2.998 14.248', 'M20.998 9.748L23.248 11.998 20.998 14.248', 'M5.95,16.5a6.75,6.75,0,1,1,12.1,0']],
  GestureTapExpandAllDirections1: ['gesture-tap-expand-all-directions-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.25 2.998L12 0.748 9.75 2.998', 'M14.25 20.998L12 23.248 9.75 20.998', 'M3 9.748L0.75 11.998 3 14.248', 'M21 9.748L23.25 11.998 21 14.248', 'M10.61,17.248,6.82,14.155a1.636,1.636,0,0,1-.565-1.676h0a1.638,1.638,0,0,1,2.321-1.068L9.75,12V6.748a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v3l1.993.333A3,3,0,0,1,17.25,13.04v4.208']],
  GestureTapSwipeLeft1: ['gesture-tap-swipe-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.608,22.248l-3.789-3.093a1.639,1.639,0,0,1-.566-1.676h0a1.638,1.638,0,0,1,2.321-1.068L15.748,17v-6.75a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333a3,3,0,0,1,2.507,2.959v4.208', 'M0.748 7.248L8.248 7.248', 'M4.498 3.498L0.748 7.248 4.498 10.998', 'M13.005,12.241a6,6,0,1,1,8.486,0']],
  GestureTwoFingerFlipRight: ['gesture-two-finger-flip-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.936 18.704L16.623 22.935 20.854 23.248', 'M16.625,22.91a26.95,26.95,0,0,0,6.625-6.5', 'M7.424 6.081L8.715 2.04 4.674 0.748', 'M8.707,2.063A26.985,26.985,0,0,0,.75,6.835', 'M19.451,14.993a5.567,5.567,0,0,0-.7-1.5h0l2.178-3.937A1.5,1.5,0,1,0,18.3,8.109l-2.692,4.866-1.361-.227v-6a1.5,1.5,0,1,0-3,0V15l-1.174-.587a1.638,1.638,0,0,0-1.755,2.744l3.789,3.093']],
  GestureTapTwoFingers1: ['gesture-tap-two-fingers-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.249 17.249L6.749 17.249', 'M3.749,23.249V16.5a3.75,3.75,0,0,1,7.5,0v6.75', 'M15.749 12.749L14.249 12.749', 'M11.249,23.249V12a3.75,3.75,0,1,1,7.5,0v11.25', 'M7.5,8.249A6.75,6.75,0,0,0,.749,15', 'M21.749,15.192a8.152,8.152,0,0,0,1.5-4.693A8.229,8.229,0,0,0,8.666,5.249']],
  GestureTwoFingersHorizontalZoomIn: ['gesture-two-fingers-horizontal-zoom-in', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.247,23l.816-2.856a3,3,0,0,0-1.542-3.507l-.774-.387V12.5a1.5,1.5,0,1,0-3,0V11a1.5,1.5,0,1,0-3,0v6.75l-1.174-.587a1.638,1.638,0,0,0-1.755,2.744L10.607,23', 'M12.747 12.498L12.747 16.998', 'M4.498 1.248L0.748 4.998 4.498 8.748', 'M0.748 4.998L23.248 4.998', 'M19.498 1.248L23.248 4.998 19.498 8.748']],
  GestureTwoFingerTapClock: ['gesture-two-finger-tap-clock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.378,14.486a9.2,9.2,0,0,0,.845-1.736', 'M14.250 5.248 A4.500 4.500 0 1 0 23.250 5.248 A4.500 4.500 0 1 0 14.250 5.248 Z', 'M18.75 5.248L18.75 3.748', 'M12,1.065A8.9,8.9,0,0,0,9.75.748,8.979,8.979,0,0,0,2.44,14.97', 'M14.249,23.248l.816-2.856a3,3,0,0,0-1.543-3.507l-.773-.387v-3.75a1.5,1.5,0,0,0-3,0v-1.5a1.5,1.5,0,0,0-3,0V18l-1.174-.587A1.638,1.638,0,0,0,3.82,20.155l3.789,3.093', 'M9.749 12.748L9.749 17.248']],
  GestureZoomIn: ['gesture-zoom-in', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.94 15.715L5.4 15.373', 'M10.32,23.248,8.151,13.961a3.75,3.75,0,0,0-7.3,1.705l1.77,7.582', 'M20.057 15.715L18.597 15.373', 'M21.379,23.248l1.77-7.582a3.75,3.75,0,1,0-7.3-1.7l-2.169,9.287', 'M6.561 6.748L9.206 3.431 5.888 0.786', 'M9.206,3.444A35.959,35.959,0,0,0,.749,5.133', 'M17.436 6.748L14.791 3.431 18.109 0.786', 'M14.791,3.444a35.977,35.977,0,0,1,8.458,1.689']],
  GestureSwipeVerticalUp2: ['gesture-swipe-vertical-up-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25,12.109,5.344,8.32a1.633,1.633,0,0,1,1.675-.566h0a1.637,1.637,0,0,1,1.068,2.321L7.5,11.249h6.75a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5H9.75l-.332,1.993a3,3,0,0,1-2.959,2.507H2.25', 'M21.75 0.748L15.75 0.748 15.75 6.748', 'M18.371,23.248A18,18,0,0,0,17.165.748']],
  GestureSwipeHorizontal3: ['gesture-swipe-horizontal-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.608,20.748,6.819,17.655a1.639,1.639,0,0,1-.566-1.676h0a1.638,1.638,0,0,1,2.321-1.068l1.174.587V8.748a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333a3,3,0,0,1,2.507,2.959v4.208', 'M0.748 7.248L5.998 7.248', 'M4.498 3.498L0.748 7.248 4.498 10.998', 'M15.748 7.248L23.248 7.248', 'M19.498 3.498L23.248 7.248 19.498 10.998']],
  GestureTapVerticalExpand: ['gesture-tap-vertical-expand', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.109,22.5l-3.79-3.093a1.639,1.639,0,0,1-.566-1.676h0a1.639,1.639,0,0,1,2.321-1.068l1.175.587V10.5a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5V15l1.993.333a3,3,0,0,1,2.507,2.959V22.5', 'M3.748 3.748L0.748 6.748 3.748 9.748', 'M20.248 3.748L23.249 6.748 20.248 9.748', 'M16.724,9a5.243,5.243,0,1,0-8.476,1.417']],
  GestureFlipLeft: ['gesture-flip-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.939 11.964L5.4 11.623', 'M9.1,14.257l-.945-4.046a3.75,3.75,0,0,0-7.3,1.705L2.618,19.5', 'M20.057 11.964L18.596 11.623', 'M21.378,19.5l1.771-7.582a3.75,3.75,0,0,0-7.3-1.7L14.9,14.244', 'M10.784 17.272L8.062 20.526 11.315 23.248', 'M8.077,20.507A26.961,26.961,0,0,0,17.248,19.1', 'M13.088 6.748L16.494 4.219 13.965 0.813', 'M16.481,4.235a26.95,26.95,0,0,0-9.253-.767']],
  GestureZoomOut: ['gesture-zoom-out', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.939 15.715L5.4 15.373', 'M10.32,23.248,8.151,13.961a3.75,3.75,0,0,0-7.3,1.705l1.771,7.582', 'M20.057 15.715L18.597 15.373', 'M21.379,23.248l1.77-7.582a3.75,3.75,0,1,0-7.3-1.7l-2.169,9.287', 'M19.458 6.649L23.248 4.743 21.342 0.953', 'M23.248,4.764a26.941,26.941,0,0,0-9-2.353', 'M4.539 6.649L0.748 4.743 2.654 0.953', 'M.748,4.764a26.953,26.953,0,0,1,9-2.353']],
  GestureSwipeHorizontalRightTwoFingers: ['gesture-swipe-horizontal-right-two-fingers', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.249 0.748L23.249 6.748 17.249 6.748', 'M.749,4.128a18,18,0,0,1,22.5,1.205', 'M8.249 17.248L6.749 17.248', 'M3.749,23.248V16.5a3.75,3.75,0,0,1,7.5,0v6.75', 'M15.749 15.748L14.249 15.748', 'M11.249,23.248V15a3.75,3.75,0,1,1,7.5,0v8.25']],
  GestureTapAllDirection1: ['gesture-tap-all-direction-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.249 2.998L11.999 0.748 9.749 2.998', 'M14.249 20.998L11.999 23.248 9.749 20.998', 'M2.999 9.748L0.749 11.998 2.999 14.248', 'M20.999 9.748L23.249 11.998 20.999 14.248', 'M5.999 9.748L4.499 11.998 5.999 14.248', 'M17.999 9.748L19.499 11.998 17.999 14.248', 'M14.249 5.998L11.999 4.498 9.749 5.998', 'M14.249 17.998L11.999 19.498 9.749 17.998', 'M11.249 12.748L12.749 12.748', 'M15.749,15V12a3.75,3.75,0,0,0-7.5,0v3']]
};
exports["default"] = _default;